import React from "react";

const PrivacyPolicy = () => {
  return (
    <div>
      {/* Breadcrumbs Section */}
      <div className="breadcrumbs overlay">
        <div className="container">
          <div className="bread-inner">
            <div className="row">
              <div className="col-12">
                <ul className="bread-list">
                  <li><a href="/">Home</a></li>
                  <li><i className="icofont-simple-right"></i></li>
                  <li className="active">Privacy Policy</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Privacy Policy Section */}
      <section className="privacy-policy section">
        <div className="container">
          <div className="inner">
            <div className="row">
              <div className="col-lg-12">
                <div className="privacy-policy-content">
                  <div className="section">
                    <h2>1. Introduction</h2>
                    <p>
                      Financial Pros Online ("we," "our," or "us") is committed to protecting your privacy. 
                      This Privacy Policy explains how we collect, use, disclose, and safeguard your information 
                      when you visit our website at financialprosonline.com and use our financial services.
                    </p>
                    <p>
                      By using our website and services, you consent to the data practices described in this policy.
                    </p>
                  </div>

                  <div className="section">
                    <h2>2. Information We Collect</h2>
                    
                    <h3>2.1 Personal Information</h3>
                    <p>We may collect the following personal information:</p>
                    <ul>
                      <li>Name and contact information (email address, phone number)</li>
                      <li>Financial information for retirement planning calculations</li>
                      <li>Age, retirement goals, and financial objectives</li>
                      <li>Current savings and investment information</li>
                      <li>Communication preferences</li>
                    </ul>

                    <h3>2.2 Automatically Collected Information</h3>
                    <p>When you visit our website, we automatically collect:</p>
                    <ul>
                      <li>IP address and browser type</li>
                      <li>Pages visited and time spent on our site</li>
                      <li>Referring website information</li>
                      <li>Device information and operating system</li>
                      <li>Cookies and similar tracking technologies</li>
                    </ul>
                  </div>

                  <div className="section">
                    <h2>3. How We Use Your Information</h2>
                    <p>We use the collected information for the following purposes:</p>
                    <ul>
                      <li>Provide financial planning and retirement calculation services</li>
                      <li>Personalize your experience and improve our services</li>
                      <li>Communicate with you about our services and updates</li>
                      <li>Send newsletters and marketing materials (with your consent)</li>
                      <li>Analyze website usage and improve user experience</li>
                      <li>Comply with legal obligations and protect our rights</li>
                    </ul>
                  </div>

                  <div className="section">
                    <h2>4. Information Sharing and Disclosure</h2>
                    <p>We do not sell, trade, or otherwise transfer your personal information to third parties, except in the following circumstances:</p>
                    <ul>
                      <li><strong>Service Providers:</strong> We may share information with trusted third-party service providers who assist us in operating our website and providing services</li>
                      <li><strong>Legal Requirements:</strong> We may disclose information when required by law or to protect our rights and safety</li>
                      <li><strong>Business Transfers:</strong> In the event of a merger, acquisition, or sale of assets, your information may be transferred</li>
                      <li><strong>Consent:</strong> We may share information with your explicit consent</li>
                    </ul>
                  </div>

                  <div className="section">
                    <h2>5. Data Security</h2>
                    <p>We implement appropriate security measures to protect your personal information:</p>
                    <ul>
                      <li>Encryption of sensitive data during transmission</li>
                      <li>Secure servers and data storage facilities</li>
                      <li>Regular security assessments and updates</li>
                      <li>Limited access to personal information on a need-to-know basis</li>
                      <li>Employee training on data protection practices</li>
                    </ul>
                  </div>

                  <div className="section">
                    <h2>6. Cookies and Tracking Technologies</h2>
                    <p>Our website uses cookies and similar technologies to:</p>
                    <ul>
                      <li>Remember your preferences and settings</li>
                      <li>Analyze website traffic and usage patterns</li>
                      <li>Improve website functionality and user experience</li>
                      <li>Provide personalized content and advertisements</li>
                    </ul>
                    <p>You can control cookie settings through your browser preferences.</p>
                  </div>

                  <div className="section">
                    <h2>7. Third-Party Links</h2>
                    <p>
                      Our website may contain links to third-party websites. We are not responsible for the privacy 
                      practices or content of these external sites. We encourage you to review their privacy policies 
                      before providing any personal information.
                    </p>
                  </div>

                  <div className="section">
                    <h2>8. Your Rights and Choices</h2>
                    <p>You have the following rights regarding your personal information:</p>
                    <ul>
                      <li><strong>Access:</strong> Request access to your personal information</li>
                      <li><strong>Correction:</strong> Request correction of inaccurate information</li>
                      <li><strong>Deletion:</strong> Request deletion of your personal information</li>
                      <li><strong>Portability:</strong> Request a copy of your data in a portable format</li>
                      <li><strong>Opt-out:</strong> Unsubscribe from marketing communications</li>
                      <li><strong>Restriction:</strong> Request restriction of processing</li>
                    </ul>
                  </div>

                  <div className="section">
                    <h2>9. Children's Privacy</h2>
                    <p>
                      Our services are not intended for children under 13 years of age. We do not knowingly collect 
                      personal information from children under 13. If you believe we have collected information from 
                      a child under 13, please contact us immediately.
                    </p>
                  </div>

                  <div className="section">
                    <h2>10. International Data Transfers</h2>
                    <p>
                      Your information may be transferred to and processed in countries other than your own. 
                      We ensure appropriate safeguards are in place to protect your information in accordance 
                      with this Privacy Policy.
                    </p>
                  </div>

                  <div className="section">
                    <h2>11. Changes to This Privacy Policy</h2>
                    <p>
                      We may update this Privacy Policy from time to time. We will notify you of any material 
                      changes by posting the new policy on our website and updating the "Last updated" date. 
                      Your continued use of our services after such changes constitutes acceptance of the updated policy.
                    </p>
                  </div>

                  <div className="section">
                    <h2>12. Contact Us</h2>
                    <p>If you have any questions about this Privacy Policy or our data practices, please contact us:</p>
                    <div className="contact-info">
                      <p><strong>Email:</strong> info@financialprosonline.com</p>
                      <p><strong>Website:</strong> financialprosonline.com</p>
                      <p><strong>Business Hours:</strong> Monday - Friday 7:00-10:00, Saturday - Sunday 12:00-6:00</p>
                    </div>
                  </div>

                  <div className="section">
                    <h2>13. Financial Services Specific Information</h2>
                    <p>As a financial services provider, we handle sensitive financial information. We are committed to:</p>
                    <ul>
                      <li>Maintaining strict confidentiality of your financial data</li>
                      <li>Using industry-standard security measures for financial information</li>
                      <li>Complying with applicable financial regulations and privacy laws</li>
                      <li>Providing secure retirement planning and financial calculation tools</li>
                      <li>Protecting your financial goals and objectives</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <style jsx>{`
        .privacy-policy-content {
          background: white;
          padding: 40px;
          border-radius: 8px;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }

        .privacy-policy-content .section {
       
          border-bottom: 1px solid #f0f0f0;
        }

        .privacy-policy-content .section:last-child {
          border-bottom: none;
          margin-bottom: 0;
          padding-bottom: 0;
        }

        .privacy-policy-content .section h2 {
          color: #004a99;
          font-size: 1.5rem;
          margin-bottom: 15px;
          font-weight: 600;
        }

        .privacy-policy-content .section h3 {
          color: #333;
          font-size: 1.1rem;
          margin: 20px 0 10px 0;
          font-weight: 500;
        }

        .privacy-policy-content .section p {
          line-height: 1.6;
          color: #555;
          margin-bottom: 12px;
          font-size: 14px;
        }

        .privacy-policy-content .section ul {
          margin-left: 20px;
          margin-bottom: 12px;
        }

        .privacy-policy-content .section li {
          line-height: 1.6;
          color: #555;
          margin-bottom: 6px;
          font-size: 14px;
        }

        .privacy-policy-content .contact-info {
          background-color: #f8f9fa;
          padding: 15px;
          border-radius: 6px;
          border-left: 3px solid #004a99;
          margin-top: 10px;
        }

        .privacy-policy-content .contact-info p {
          margin-bottom: 8px;
          font-size: 14px;
        }

        @media (max-width: 768px) {
          .privacy-policy-content {
            padding: 25px 20px;
          }
          
          .privacy-policy-content .section h2 {
            font-size: 1.3rem;
          }
          
          .privacy-policy-content .section {
            margin-bottom: 20px;
            padding-bottom: 15px;
          }
        }
      `}</style>
    </div>
  );
};

export default PrivacyPolicy; 